import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketPriority } from '../../../core/models/ticket.model';

@Component({
  selector: 'app-priority-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span [class]="badgeClasses()">
      <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        @if (priority() === 'Critical' || priority() === 'Urgent') {
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
        } @else {
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
        }
      </svg>
      {{ priority() }}
    </span>
  `
})
export class PriorityBadgeComponent {
  readonly priority = input.required<TicketPriority>();

  readonly badgeClasses = computed(() => {
    const base = 'inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold uppercase tracking-wider';
    switch (this.priority()) {
      case 'Critical': return `${base} bg-rose-100 text-rose-800 border border-rose-200`;
      case 'Urgent': return `${base} bg-orange-100 text-orange-800 border border-orange-200`;
      case 'High': return `${base} bg-amber-100 text-amber-800 border border-amber-200`;
      case 'Medium': return `${base} bg-slate-100 text-slate-700 border border-slate-200`;
      case 'Low': return `${base} bg-emerald-100 text-emerald-800 border border-emerald-200`;
      default: return `${base} bg-gray-100 text-gray-700`;
    }
  });
}
